'use strict';

require('./CompanyInfoService.js');
require('./publications/CompanyPublicationService.js');
require('./user-roles/CompanyUserRoleService.js');

function CompanyMenuTopCtrl(
  $scope,
  $rootScope,
  $state,
  $stateParams,
  $translate,
  growl,
  $document,
  CompanyPublicationService,
  CompanyInfoService,
  info,
  userRoles
) {

  $scope.info = info;
  $scope.$on('companyInfoChanged', function(){
    return CompanyInfoService.get({companyId: $stateParams.companyId}).$promise.then(function(resp){
      $scope.info = resp;
    });
  });

  $scope.userRoles = userRoles;
  angular.forEach($scope.userRoles, function(v){
    if (angular.isUndefined($scope.selectedUserrole)) {
      if (v.template && (v.template.id === '1' || v.template.id === '2' || v.template.id === '5' || v.template.id === '6')) {
        $scope.selectedUserrole = v.id;
      }
    }
  });

  $translate.onReady().then(function() {
    $rootScope.$broadcast('$translateChangeSuccess');
  });

  $scope.newOrder = new CompanyPublicationService({
    name:     "",
    status:   "PUBLISHED",
    type:     'COMPANY_ORDER',
    tags:     [],
    groups:   []
  });

  $scope.createOrder = function() {
    $scope.newOrder.$save({
      companyId: $stateParams.companyId
    }, function(resp, headers){
      var newId = headers('Location').split('/').pop();
      window.location.href = '/order/'+$stateParams.companyId+'/detail/'+newId;
      growl.addSuccessMessage($translate.instant('publication.create-success'));
    }, function(){
      growl.addErrorMessage($translate.instant('publication.create-failure'));
    });
  };
}

CompanyMenuTopCtrl.resolve = {
  userRoles: ['CompanyUserRoleService', '$stateParams', 'info', function(userRoleService, $stateParams, info) {
    if(info.features.userRole){
      return userRoleService.query({companyId: $stateParams.companyId, limit: 21, offset: 0}).$promise;
    }
    return false;
  }]
};

module.exports = CompanyMenuTopCtrl;

angular.module('dokiv')
  .controller('CompanyMenuTopCtrl', [
    '$scope',
    '$rootScope',
    '$state',
    '$stateParams',
    '$translate',
    'growl',
    '$document',
    'CompanyPublicationService',
    'CompanyInfoService',
    'info',
    'userRoles',
    CompanyMenuTopCtrl
  ]);



//////////////////
// WEBPACK FOOTER
// ./scripts/company/CompanyMenuTopCtrl.js
// module id = 312
// module chunks = 0